import {
  Combobox,
  OptionData,
} from "components/DesignSystem/Combobox/Combobox";
import { Tag } from "components/DesignSystem/Tag/Tag";
import {
  DropdownIndicator,
  TransactionComboboxControl,
} from "components/Transaction/TransactionColumn";
import { getBooksGlobalStatusColor } from "constants/booksGlobalStatus";
import { MultiValue, SingleValue } from "react-select";
import { Task } from "types/Models/task";
import { BooksTaskStatusModals } from "./BooksTaskStatusModals";
import { BooksStatusOption, BooksTaskStatus } from "./useBooksTaskStatus";

const toChipOption = (option: BooksStatusOption) => ({
  label: (
    <Tag icon={false} tagType={getBooksGlobalStatusColor(option.key)} rounded>
      {option.name}
    </Tag>
  ),
  value: option.key,
  disableOption: option.isDisabled,
});

// Combobox variant used by TaskStateDropdown (tracker table)
export const BooksTaskStatusCombobox = ({
  task,
  status,
  isVariablePricing,
}: {
  task: Task;
  status: BooksTaskStatus;
  isVariablePricing: boolean;
}) => (
  <div onClick={(e) => e.stopPropagation()}>
    <Combobox
      block
      size="small"
      isDisabled={status.isLoading || status.isCompleted}
      onChange={(prop: SingleValue<OptionData> | MultiValue<OptionData>) =>
        status.onSelect((prop as SingleValue<OptionData>)?.value)
      }
      isOptionDisabled={(option) => Boolean(option.disableOption)}
      components={{
        Control: TransactionComboboxControl,
        DropdownIndicator,
        ClearIndicator: () => null,
      }}
      options={status.options.map(toChipOption)}
      value={status.currentOption ? toChipOption(status.currentOption) : null}
      menuPortalTarget={document.body}
      styles={{
        menu: (base) => ({ ...base, width: 240 }),
      }}
    />
    <BooksTaskStatusModals
      task={task}
      status={status}
      isVariablePricing={isVariablePricing}
    />
  </div>
);
